import { useMutation, useQueryClient } from "@tanstack/react-query";
import { couponsKeys } from "Api/Queries/Coupons/useCouponsQuery";
import {
  type UpdateCouponRequest,
  putCouponsCouponID,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

type UpdateCouponParams = {
  couponID: number;
  data: UpdateCouponRequest;
};

export const useUpdateCouponMutation = ({ onSuccess, onError }: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ couponID, data }: UpdateCouponParams) =>
        putCouponsCouponID(data, couponID),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: couponsKeys.all });
      onSuccess?.();
    },
    onError,
  });
};
